<!--
 * @Author: mazhigang
 * @Date: 2023-07-01 19:16:24
 * @LastEditors: xjf
 * @LastEditTime: 2025-02-21 11:19:05
-->
<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>工作申请</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">工作申请</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="用户姓名">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.name"
                    placeholder="请输入姓名"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="状态">
                  <el-select
                    style="margin-right: auto"
                    v-model="ruleForm.isJob"
                    placeholder="请选择状态"
                  >
                    <el-option label="未联系" value="0"></el-option>
                    <el-option label="已联系" value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item>
                  <el-button type="primary" @click="getList('new')" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <div class="pageTab">
        <el-table ref="scrollTable" :data="tableData" style="width: 100%">
          <el-table-column prop="id" label="编号" align="center">
          </el-table-column>
          <el-table-column label="姓名" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.bodyguardName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="联系方式" align="center">
          </el-table-column>
          <el-table-column label="备注" align="center" width="180">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                {{ scope.row.remark }}
                <div slot="reference" class="name-wrapper">
                  <div class="omit">{{ scope.row.remark }}</div>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="处理状态" align="center">
            <template slot-scope="scope">
              <span class="blueColor" v-if="scope.row.isContact == 0"
                >未联系</span
              >
              <span class="greenColor" v-if="scope.row.isContact == 1"
                >已联系</span
              >
              <span class="redColor" v-if="scope.row.isJob == 1">服务中</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="gmtCreate"
            label="创建时间"
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column label="操作" align="center" fixed="right">
            <template slot-scope="scope">
              <div class="disAround" v-if="scope.row.isContact == 0">
                <div class="operateBtn" @click="handleEdit(scope.row)">
                  处理
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <TableScrollSlider :table-ref="$refs.scrollTable" />
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="联系处理"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClose"
    >
      <div class="infoBox">
        <div class="infoItem" style="width: 100%">
          <el-select
            style="margin-right: auto"
            v-model="state"
            placeholder="请选择处理状态"
          >
            <el-option label="未联系" value="0"></el-option>
            <el-option label="已联系" value="1"></el-option>
          </el-select>
        </div>

        <div class="infoItem">
          <div
            style="display: inline-block; margin-bottom: 10px; margin-top: 30px"
          >
            联系结果
          </div>
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入联系结果"
            v-model="textarea"
          >
          </el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="shenhe()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import system from "../../components/system_left.vue";
import Template from "../template/template.vue";
export default {
  components: {
    system,
  },
  Template,
  data() {
    return {
      leftList: this.Plugins.askariData(),
      ruleForm: {
        name: "",
        status: "",
      },
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      selectData: {},
      state: "",
      textarea: "",
    };
  },
  mounted() {
    this.getList();
  },
  computed: {},
  computed: {},
  methods: {
    shenhe() {
      console.log(this.state);
      if (this.state == "") {
        this.$message({
          message: "请选择审核状态",
          type: "warning",
        });
        return;
      }
      if (this.state == 0) {
        if (this.textarea == "") {
          this.$message({
            message: "请输入拒绝原因",
            type: "warning",
          });
          return;
        }
      }
      let param = {
        id: this.selectData.id,
        remark: this.textarea,
        isContact: this.state,
      };
      this.$axios
        .post(`/admapi/veteranwork/contract`, param)
        .then(({ data }) => {
          this.$message({
            message: "审核成功",
            type: "success",
          });
          this.dialogVisible = false;
          this.getList();
        })
        .catch()
        .finally();
    },
    goDetail(val) {
      this.$router.push({
        path: "/askariDetail",
        query: {
          id: val.id,
        },
      });
    },
    handleEdit(val) {
      this.state = "";
      this.textarea = "";
      this.selectData = val;
      this.dialogVisible = true;
    },
    handleClose() {
      this.state = "";
      this.textarea = "";
      this.selectData = {};
      this.dialogVisible = false;
    },
    handleClose1() {
      // this.qrText = "";
      this.selectData = {};
      this.url = "";
      this.textUnderQr = "";
      this.dialogVisible1 = false;
    },
    resetForm() {
      this.ruleForm.name = "";
      this.ruleForm.status = "";
      this.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList() {
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        bodyguardName: this.ruleForm.name,
        isContact: this.ruleForm.status,
      };
      this.$axios
        .post(`/admapi/veteranwork/list`, param)
        .then(({ data }) => {
          this.tableData = data.items || [];
          this.total = data.page.totalRows;
        })
        .catch()
        .finally();
    },
  },
};
</script>
<style scoped>
.demo-ruleForm {
  width: 650px;
}

.infoBox {
  display: flex;
  flex-wrap: wrap;
}

.infoItem {
  width: 300px;
  margin-bottom: 10px;
}

.infoItem img {
  width: 200px;
  height: 150px;
}
.qr-code-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 20px;
}

.display-canvas {
  width: 300px;
  height: 330px;
  image-rendering: -moz-crisp-edges;
  image-rendering: -webkit-crisp-edges;
  image-rendering: pixelated;
  image-rendering: crisp-edges;
  border: 1px solid #eee;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.render-canvas {
  display: none;
}

.controls {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  max-width: 300px;
}
.link {
  padding: 8px 16px;
  background: #1890ff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.omit {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /* 控制显示的行数 */
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word; /* 长单词或 URL 换行 */
  line-height: 1.4; /* 可选：设置行高 */
  max-height: 40px; /* 可选：line-height * 2，用于更好的兼容性 */
}
</style>
